<template>
  <div v-if="loadingCompleted">
    <div class="d-flex justify-content-around font-size-sm mcf-footer">
      <div class="px-2 py-1 d-flex flex-column align-items-center justify-content-center text-center position-relative" :class="{ 'current': currentItem === menu.functionName }"
       v-for="menu in menus" :key="menu.functionName" @click="redirect(menu)">
        <span :class="menu.iconClass">
          {{ menu.iconName }}
        </span>
        <span class="mt-n1">{{ getWording(menu.wording) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import commonTool from '../utils/commonTool';

export default {
  props: {
    // 當前項目
    currentItem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 資料是否完成載入
      loadingCompleted: false,
      // 預設語言
      defaultLang: '',
      // 選單列表
      menus: [],
      // 有開啟網訊商城連結
      isTEECLink: false,
      // 商城連結
      storeUrl: '',
    };
  },
  created() {
    const vm = this;
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.defaultLang = setting.defaultLanguage;

        let promise = Promise.resolve();
        vm.isTEECLink = setting.isTEECLink;
        // 有開啟網訊商城連結 => 前往商城；否則為原功能
        if (setting.isTEECLink) {
          promise = commonTool.getPersonalStoreUrl().toPromise().then((url) => {
            vm.storeUrl = url;
          });
        }
        return promise;
      });

    const getClientNavigationMenu = vm.$store.dispatch('getClientNavigationMenu')
      .then((menus) => {
        if (!menus) return;
        vm.menus = menus;
      });

    Promise.all([getPageSetting, getClientNavigationMenu])
      .then(() => {
        vm.loadingCompleted = true;
      });
  },
  methods: {
    // 依使用者語系取得文案
    getWording(wordings) {
      const wording = wordings.find((x) => x.language === this.defaultLang);

      return wording.value;
    },
    // 導向指定頁面
    redirect(menu) {
      const vm = this;

      // 有開啟網訊商城連結 & 且功能為首頁 => 前往商城；否則為原功能
      if (vm.isTEECLink && menu.functionName === 'BrandHomePage') {
        window.open(vm.storeUrl);
      }

      if (menu.url) {
        window.open(menu.url);
        return;
      }
      vm.$router.push({ path: `/${menu.functionName}`, query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
  },
};
</script>
